// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-info .text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.status-badge.success {
  background-color: rgba(76, 175, 80, 0.15);
  color: #2e7d32;
}
.status-badge.warning {
  background-color: rgba(255, 152, 0, 0.15);
  color: #e65100;
}
.status-badge.info {
  background-color: rgba(33, 150, 243, 0.15);
  color: #1565c0;
}
.status-badge.unknown {
  background-color: rgba(158, 158, 158, 0.15);
  color: #616161;
}

.waveform-container {
  position: relative;
  background: var(--ion-color-light);
  border-radius: 12px;
  padding: 16px;
  min-height: 112px;
}
.waveform-container .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--ion-color-light);
  border-radius: 12px;
  z-index: 10;
}
.waveform-container .waveform {
  width: 100%;
  min-height: 80px;
}

.time-display {
  padding: 0 4px;
}

.controls {
  padding: 16px 0;
}
.controls .play-button {
  --padding-start: 24px;
  --padding-end: 24px;
  --padding-top: 24px;
  --padding-bottom: 24px;
  width: 72px;
  height: 72px;
}
.controls .play-button ion-icon {
  font-size: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/audio-player-modal/audio-player-modal.page.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAIE;EACE,yCAAA;EACA,cAAA;AAFJ;AAKE;EACE,yCAAA;EACA,cAAA;AAHJ;AAME;EACE,0CAAA;EACA,cAAA;AAJJ;AAOE;EACE,2CAAA;EACA,cAAA;AALJ;;AASA;EACE,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AANF;AAQE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,WAAA;AANJ;AASE;EACE,WAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,eAAA;AARF;AAUE;EACE,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AARJ;AAUI;EACE,eAAA;AARN","sourcesContent":[".audio-info {\n  .text-ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// 狀態標籤（複用 mak-device-mp3 的樣式）\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n\n  &.success {\n    background-color: rgba(76, 175, 80, 0.15);\n    color: #2e7d32;\n  }\n\n  &.warning {\n    background-color: rgba(255, 152, 0, 0.15);\n    color: #e65100;\n  }\n\n  &.info {\n    background-color: rgba(33, 150, 243, 0.15);\n    color: #1565c0;\n  }\n\n  &.unknown {\n    background-color: rgba(158, 158, 158, 0.15);\n    color: #616161;\n  }\n}\n\n.waveform-container {\n  position: relative;\n  background: var(--ion-color-light);\n  border-radius: 12px;\n  padding: 16px;\n  min-height: 112px;\n\n  .loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: var(--ion-color-light);\n    border-radius: 12px;\n    z-index: 10;\n  }\n\n  .waveform {\n    width: 100%;\n    min-height: 80px;\n  }\n}\n\n.time-display {\n  padding: 0 4px;\n}\n\n.controls {\n  padding: 16px 0;\n\n  .play-button {\n    --padding-start: 24px;\n    --padding-end: 24px;\n    --padding-top: 24px;\n    --padding-bottom: 24px;\n    width: 72px;\n    height: 72px;\n\n    ion-icon {\n      font-size: 32px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
